/* eslint-disable prettier/prettier */
import React from 'react';
import { useHistory } from 'react-router-dom';

import useStoreTranslation from 'hooks/useStoreTranslation';
import useUserAccount from 'hooks/useUserAccount';

import ResponseScreen, { BackgroundTypes, IconTypes } from '../ResponseScreen';

type Props = {
  show: boolean;
  isHotel?: boolean;
  isFlight?: boolean;
  testId?: string;
  tid?: string;
};

const SolicitationSuccess = ({ show, isHotel, isFlight, testId, tid }: Props) => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const user = useUserAccount();

  const handleButtonClick = () => {
    if (user?.isGroupApprover) {
      history.replace('/corporate/dashboard');
    } else {
      history.replace('/corporate/travelRequested');
    }
  };

  return (
    <ResponseScreen
      show={show}
      text={t('solicitationSuccess.text')}
      subText={t(
        isHotel
          ? 'solicitationSuccess.subTextHotel'
          : isFlight
          ? 'solicitationSuccess.subTextFlight'
          : 'solicitationSuccess.subTextVehicle',
        {
          id: tid || '',
        },
      )}
      background={BackgroundTypes.Cloud}
      buttonOnClick={handleButtonClick}
      icon={IconTypes.Airplane}
      testId={testId}
    />
  );
};

export default SolicitationSuccess;
